<template>
    <div class="startIncome_wrap spackage padding-20 bgc box-shadow">
        <div class="Income_top">
            <div>
                <p>今日收入（元）</p>
                <p>￥{{todayincome}}</p>
            </div>
            <div>
                <p>昨日收入（元）</p>
                <p>￥{{yesterdayincome}}</p>
            </div>
            <div>
                <p>近7日收入（元）</p>
                <p>￥{{weekdayincome}}</p>
            </div>
            <div>
                <p>近30日收入（元）</p>
                <p>￥{{monthdayincome}}</p>
            </div>
        </div>
        <div class="Income_Bottom">
            <div class="title">| <span>基本信息</span></div>
            <div class="bottom_flex" style="display: flex">
                <el-tabs v-model="activeName" @tab-click="handleClick" class="tablist_noLine">
                    <el-tab-pane label="今日" name='0'></el-tab-pane>
                    <el-tab-pane label="昨日" name='1'></el-tab-pane>
                    <el-tab-pane label="本周" name='6'></el-tab-pane>
                    <el-tab-pane label="本月" name='29'></el-tab-pane>
                    <el-tab-pane name="zdy">
                    <span slot="label">
                        <div class="block">
                            <el-date-picker class="dateInput" v-model="param.date" type="daterange" align="right" unlink-panels
                                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleClick">
                            </el-date-picker>
                          </div>
                    </span>
                    </el-tab-pane>
                </el-tabs>
                <div class="bottom_btn">
                    <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
                    <el-button @click="sureDownload">导出</el-button>
                </div>
            </div>

            <el-table :data="incomeData">
                <el-table-column prop="orderno" label="订单号" align="center"></el-table-column>
                <el-table-column prop="paytime" label="时间" align="center"></el-table-column>
                <el-table-column prop="paytypename" label="交易方式" align="center"></el-table-column>
                <el-table-column prop="finalpaymoney" label="支付金额（元）" align="center"></el-table-column>
                <el-table-column prop="memo" label="备注" align="center"></el-table-column>
            </el-table>
            <page :total="total" ref="page" @getList="searchClick"></page>
        </div>
    </div>
</template>

<script>
    import {getStarIncome,findStarPayOrderList,starPayOrderExportList} from '@/api/communityApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'
    import Page from 'base/page/page'
    import fecha from 'element-ui/src/utils/date';
    import {dateFormat} from 'common/js/tools'

    export default {
        name: "startIncome",
        data() {
            return {
                value1: '', //日期
                CommentData: [], //列表数据
                total: 0,
                param: {
                    date: [], // 开始/结束时间
                    status: '1' // 1今日 2昨日 3近7日 4近30天 5自定义
                },
                searchName: '', //搜索文字
                topData: [],
                incomeData:[],
                todayincome: '',
                yesterdayincome: '',
                weekdayincome: '',
                monthdayincome: '',
                activeName:'0',
                downTpm:'',
                tpm: {
                    beginTime: '',
                    endTime: ''
                }
            }
        },
        components: {
            Loading,
            Page
        },
        mounted() {
            this.setLoading(true);
            this.apiData = {
                innerid: this.$route.query.innerid,
                page: 1,
                pageSize: 10
            };
            this.topIncomeEvent();
            this.indexInfo();
        },
        watch: {
            'param.date': {
                handler(newV, oldV) {
                    let tmp = {
                        status: this.param.status,
                        begintime: this._time(newV[0]),
                        endtime: this._time(newV[1])
                    };
                    this.findStarPayOrderList(tmp);
                    this.downTpm = tmp
                }
            },
            deep: true
        },
        methods: {
            ...mapActions([
                'setLoading'
            ]),
            indexInfo() {
                const date = new Date(),
                    tpm = {
                        beginTime: this._time(date.getTime()),
                        endTime: this._time(date.getTime())
                    };
                this.findStarPayOrderList(tpm)
            },
            handleQuery() {
                this.$refs.page.handleSizeChange(1)
            },
            _time(time) {
                const temp = new Date(time);
                return fecha.format(temp, 'yyyy-MM-dd');
            },
            handleClick(tab, event) {
                if (tab.name !== 'zdy') {
                    if (event.srcElement.className !== "el-tabs__item is-top is-active") {
                        const date = new Date(),
                            tpm = this.tpm;
                        this.param.type = tab.type;

                        if (tab.name === '0') {
                            tpm.beginTime = this._time(date.getTime())
                        } else {
                            tpm.beginTime = this._time(date.getTime() - 3600 * 1000 * 24 * parseInt(tab.name))
                        }
                        if (tab.name === '1') {
                            tpm.endTime = this._time(date.getTime() - 3600 * 1000 * 24 * parseInt(tab.name))
                        } else {
                            tpm.endTime = this._time(date.getTime())
                        }
                        this.findStarPayOrderList(tpm)
                    }
                }
            },
            //上面统计数据
            topIncomeEvent() {
                getStarIncome({
                    data: this.apiData,
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.todayincome = data.data.todayincome;
                        this.yesterdayincome = data.data.yesterdayincome;
                        this.weekdayincome = data.data.weekdayincome;
                        this.monthdayincome = data.data.monthdayincome;
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg);
                    }
                })
            },
            // 表格数据列表
            findStarPayOrderList(tmp){
                findStarPayOrderList({
                    data: {
                        innerid:this.$route.query.innerid,
                        beginTime: tmp.beginTime||tmp.begintime,
                        endTime: tmp.endTime||tmp.endtime,
                        page: 1,
                        pageSize: 10
                    },
                    success: data => {
                        console.log(data);
                        this.setLoading(false);
                        this.incomeData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg);
                    }
                })
            },
            // 确认导出
            sureDownload(){
                const params={
                    innerid:this.$route.query.innerid,
                    beginTime: this.downTpm.beginTime||this.downTpm.begintime,
                    endTime: this.downTpm.endTime||this.downTpm.endtime,
                };
                starPayOrderExportList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'});
                        let fileName = '星球收入名单' + dateFormat(new Date()) + '.xls';
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            const link = document.createElement('a');
                            link.href = window.URL.createObjectURL(blob);
                            link.download = fileName;
                            link.click(); // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false);
                        this.$message.error(data.msg)
                    }
                })
            },
            // 搜索
            searchClick() {
                this.setLoading(true);
                let params = {
                    innerid: this.$route.query.innerid,
                    keyword: this.searchName,
                    beginTime: this.downTpm.beginTime||this.downTpm.begintime,
                    endTime: this.downTpm.endTime||this.downTpm.endtime,
                };
                findStarPayOrderList({
                    data: Object.assign({}, params, this.page),
                    success: data => {
                        this.setLoading(false);
                        this.CommentData = data.data.content;
                        this.total = data.data.pageinfo.rowCount
                    },
                    error: data => {
                        console.log('error：', data);
                        this.setLoading(false)
                    }
                })
            },
        },
        computed: {
            ...mapGetters([
                'page',
                'user'
            ])
        },
    }
</script>

<style lang="scss">
    .Income_top {
        width: 100%;
        height: 120px;
        background: rgba(245, 247, 250, 1);
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        .el-tabs__active-bar,
        .el-tabs__nav-wrap::after {
            height: 0
        }
        div {
            height: 80px;
            border-right: 1px solid #e5e5e5;
            margin-top: 20px;
            flex: 1;
            padding-left: 20px;
            p {
                font-size: 16px;
                color: #303133;
                padding-top: 10px;
            }
            p:last-child {
                font-size: 30px;
                padding-top: 20px;
            }
        }
        div:last-child {
            border-right: none;
        }
    }
    .Income_Bottom .title {
        color: #409EFF;
        font-size: 16px;
        margin-bottom: 20px;
        span {
            color: #303133;
            font-weight: 700;
            position: relative;
            top: 2px;
        }
    }
    .bottom_btn{
        margin-left: 30px;
        margin-top: 3px;
    }
    /*样式更改*/
   .startIncome_wrap .tablist_noLine {
        .el-tabs__active-bar{
            background: none!important;
        }
        .el-tabs__nav-wrap::after{
            background: none !important;
            z-index: 0!important;
        }
    }
    .el-range-editor.el-input__inner{
        padding: 0 10px;
    }
</style>
